import { render, staticRenderFns } from "./PublicationGetter.vue?vue&type=template&id=3439b65f&scoped=true&"
import script from "./PublicationGetter.vue?vue&type=script&lang=js&"
export * from "./PublicationGetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439b65f",
  null
  
)

export default component.exports